import { SecureKeypad } from "components"
import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import useApp from 'hooks/useApp'
import Native from 'library/native'
import Lib from 'library'
import useLocalStorage from "hooks/useLocalStorage"
import { systemWebviewSelector } from "states"
import { useRecoilValue, useSetRecoilState } from "recoil"
import Global from "library/Global"
import { mydataRefreshState } from "views/home/states"

const Login = () => {

	const App = useApp()
	const Auth = useAuth()
	const navigate = useNavigate()
	const location = useLocation()
	const [useBio, setUseBio] = useLocalStorage("useBio", false)
	const webview = useRecoilValue(systemWebviewSelector)
	const setMydataRefresh = useSetRecoilState(mydataRefreshState);

	const callback = async module => {
		Global.deviceInfo(() => {
			Auth.login(module, () => {
				module.isOpen() && module.close()

				//휴면 회원 체크
				Lib.post(`/api/mb/login/drmncChk`, res => {
					console.log(res);
					if (res.code === "S000") {
						//정상

						// 최근 마이데이터 연동 1일이 지난 경우 체크하여 업데이트 처리
						setMydataRefresh("Y");
						Lib.get("/api/data/v2/lnkup/refresh/daily", data => {
							setMydataRefresh("N");
						})
						App.pushNav(location.state);
						// navigate(location.state?.from ?? "/home", { replace: true })
					} else if (res.code === "E111") {
						//휴면 계정
						App.showAlert({
							msg: `<p style="line-height:1.4">다시 만나서 반가워요!<br /><br />고객님은 1년 이상 비로그인 상태로 휴면계정으로 <br/>전환되었어요!</p>
							<p style="color:#0075ea;margin-bottom: 10px">휴면일자 : ${res.mbDrmncDt}</p>휴면해제를 클릭하시면 이전계정 그대로 다시 서비스 이용이 가능해요!`,
							type: "bottom",
							confirm: true,
							onOk: () => {
								navigate('/member/dormantCheck')
							},
							onCancel: () => {
								App.showAlert({
									msg: "휴면해제를 하지 않아 서비스가 종료됩니다",
									onOk: () => {
										Native.execute("AppManager", "appClose")
									}
								})
							},
							ok: "휴면해제",
						})
						navigate("/home");
					} else {
						console.error(res.code, res.msg)
					}
				})
			})
		});

	}

	
	const bioCallback = async (json) => {
		try {
			if (json.resultCode === "0") {

				//const info = await getDeviceInfo()
				Global.deviceInfo((info) => {
					//const info = Global.device;
					const mbId = window.localStorage.getItem("mbId")
					Lib.post("/api/mb/login/bio/auth", {
						mbId: mbId,
						osVersion: info.osVersion,
						appVersion: info.appVersion,
						model: info.model,
						pushToken: info.pushToken,
						os: info.os
					}, data => {
						Auth.setUser(data)
						Auth.setIsLogin(true)

						// 최근 마이데이터 연동 1일이 지난 경우 체크하여 업데이트 처리
						setMydataRefresh("Y");
						Lib.get("/api/data/v2/lnkup/refresh/daily", data => {
							setMydataRefresh("N");
						})

						setTimeout(() => {
							navigate(location.state?.from ?? "/")
						}, 500)
					})
				})
			} else {
				console.error(json)
			}
		} catch (reason) {
			console.error(reason)
		}
	}

	const clearLocalStorage = () => {
		
		window.localStorage.removeItem("mbId")
		window.localStorage.removeItem("didRun")
		window.localStorage.removeItem("useBio");
		const cookies = window.document.cookie.split(";")
		cookies.forEach(cookie => {
			const coo = cookie.split("=")
			window.document.cookie = `${coo[0]}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`
		})
	}

	useEffect(() => {
		App.setShowHeader(false)
		App.setShowNav(false)
		App.setTitle("")
		App.setAppBg("#ffffff")

		// call check 탈퇴 확인
		const mbId = window.localStorage.getItem("mbId")
		if (mbId) {
			cehckWidthraw(mbId)
		}

		
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	const cehckWidthraw = async (mbId) => {
		App.showLoading()

		await Lib.get({
			url: `/api/mb/inf/chck?mbId=${mbId}`,
			onSuccess: (data) => {
				console.log('onSuccess', data)
				App.hideLoading()
				if (data.mbStusCd == "WTHDR") {
					clearLocalStorage()
					window.location.reload();

				}
				
			},
			onFail: (res) => {
				clearLocalStorage()
				App.hideLoading()
				App.showAlert("연동 처리시 오류가 발생했습니다.", () => window.location.reload())
				console.log('on onFail', `${res}`)
			},
			onError: (res) => {
				clearLocalStorage()
				App.hideLoading()
				console.log('on Error', `${res}`)
				App.showAlert("연동 처리시 오류가 발생했습니다.", () => window.location.reload())
			},
		})
	}

	const chckMbId = () =>{
		// 로컬 개발시 주석처리 필요. (해당 화면 로드 후 1분안에 로그인이 필요.)
		const mbId = window.localStorage.getItem("mbId")
		if (mbId) {
			cehckWidthraw(mbId)
		}
		
	}
	return (
		<div className="page flex-column">
			{App.test && <div onClick={clearLocalStorage} style={{ textAlign: "center", zIndex: 1, marginTop: "10rem" }}>(개발) 로컬 스토리지, 캐시 비우기</div>}
			<input type="hidden" id="passInput" />
			{/* <SimpleKeypad callback={callback} more title="비밀번호를 입력해 주세요." from={from} /> */}
			<SecureKeypad input="passInput" more={useBio} callback={(module)=>{chckMbId();callback(module);}} bioCallback={(json)=>{chckMbId();bioCallback(json);}} autoClose={false} bio={true} />
		</div>
	)
}

export default Login
